import {type Properties, type PropertyDefinition, type PropertyType} from '../config/Properties.ts';

function getProperty(prefix: string, property: PropertyDefinition) {
    let s = prefix;
    if (!s.endsWith('.')) {
        s += '.';
    }
    return s + property.key;
}

function readProperty(prefix: string | undefined, property: PropertyDefinition): PropertyType | undefined {
    if (prefix) {
        const p = getProperty(prefix, property);
        const v = process.env[p];
        // todo convert
        return v;
    }
}

export function getOrUndefined<T extends PropertyType>(properties: Properties, prefix: string, property?: PropertyDefinition): T | undefined {
    return getOrDefault(properties, prefix, property);
}

export function getOrDefault<T extends PropertyType>(properties: Properties, prefix: string, property?: PropertyDefinition, defaultValue?: T) {
    if (property === undefined) {
        return defaultValue;
    }

    let value = readProperty(prefix, property);
    if (value === undefined) {
        value = properties[property.key];
    }
    if (value === undefined) {
        return defaultValue;
    }
    return value as T;
}
